/**
 * @module
 * @author Jacob Viertel <jv@onscreen.net>
 * @since 3.83.0
 */

// stargazer, bounty
import {defineRegistryElement, defineRenderElement} from '@acng/frontend-stargazer';
import {ObserveAttributes} from '@acng/frontend-bounty/dom/observe.js';
import {DETAILS} from '@acng/frontend-bounty/dom/element.js';
import {OPEN, has} from '@acng/frontend-bounty/dom/attribute.js';
// nova
import {STYLE_OPEN, swapClass} from '../service/style.js';

/**
 *
 * {@link !HTMLDetailsElement} with `data-auto-close` will be closed if you click anywhere outside.
 *
 * @example
 * ```html
 * <details>
 *   <summary>More</summary>
 *   Here is more.
 * </details>
 * ```
 * @group DOM Element
 */
export const DETAILS_OPEN = DETAILS;

defineRegistryElement(DETAILS, (name) => {
  const connect = ObserveAttributes(
    [OPEN],
    (element) => swapClass(element, STYLE_OPEN, has(element, OPEN)),
    true
  );

  defineRenderElement(name, () => connect);
});
